// extracted by mini-css-extract-plugin
export default {"route":"TermsAndConditions_route__v85He","wrapper":"TermsAndConditions_wrapper__ZS0ZI"};